export default __webpack_public_path__ + "assets/fonts/DEADPOOL_MOVIE_RUS_BY_LYAJKA.otf";